import {
  CustomParametersColumn as CustomParametersColumnConfig,
  FinalUrlSuffixColumn as FinalUrlSuffixColumnConfig,
  TrackingTemplateColumn as TrackingTemplateColumnConfig,
} from '@bingads-webui-campaign/ad-groups-data';
import {
  TrackingTemplateColumn as TrackingTemplateColumnOriginal,
  CustomParametersColumn as CustomParametersColumnOriginal,
  FinalUrlSuffixColumn as FinalUrlSuffixColumnOriginal,
} from '@bingads-webui-campaign/tracking-template-columns';

export class TrackingTemplateColumn extends TrackingTemplateColumnOriginal {
  constructor(options) {
    super({
      ...TrackingTemplateColumnConfig,
      ...options,
      enableEdit: item => item.Campaign && item.Campaign.CampaignType !== 'LinkedIn',
    });
  }
}

export class FinalUrlSuffixColumn extends FinalUrlSuffixColumnOriginal {
  constructor(options) {
    super({
      ...FinalUrlSuffixColumnConfig,
      ...options,
      enableEdit: item => item.Campaign && item.Campaign.CampaignType !== 'LinkedIn',
    });
  }
}

export class CustomParametersColumn extends CustomParametersColumnOriginal {
  constructor(options) {
    super({
      ...CustomParametersColumnConfig,
      ...options,
      enableEdit: item => item.Campaign && item.Campaign.CampaignType !== 'LinkedIn',
    });
  }
}
